import React from "react";

const PersonalMedicalHistorySection = ({
  isActiveTreatment,
  onActiveTreatmentChange,
  activeTreatmentNotes,
  onActiveTreatmentNotesChange,
}) => {
  return (
    <div className="relative mt-4 z-10 px-4">
      <div className="rounded-2xl border border-sky-200 bg-white shadow-sm overflow-hidden">
        <div className="px-4 py-3 border-b border-sky-100 bg-sky-50">
          <h2 className="font-fatfrank text-lg md:text-xl text-sas-primary">
            Personal Medical History
          </h2>
        </div>
        <div className="p-4">
          <label
            htmlFor="active-treatment"
            className="inline-flex items-center gap-3 cursor-pointer"
          >
            <input
              id="active-treatment"
              type="checkbox"
              className="h-4 w-4 rounded border border-slate-300 text-sas-primary focus:ring-2 focus:ring-sas-primary/30"
              checked={isActiveTreatment}
              onChange={onActiveTreatmentChange}
            />
            <span className="text-sm font-semibold text-sas-primary-dark font-montserrat">
              Active treatment
            </span>
          </label>

          {isActiveTreatment ? (
            <div className="mt-4">
              <label
                className="block text-xs font-semibold uppercase tracking-[0.18em] text-sas-primary mb-2"
                htmlFor="active-treatment-notes"
              >
                Specific conditions
              </label>
              <textarea
                id="active-treatment-notes"
                rows="4"
                className="w-full rounded-xl border border-slate-200 px-4 py-3 font-semibold text-sas-primary-dark font-montserrat text-base focus:outline-none focus:ring-2 focus:ring-sas-primary/30"
                value={activeTreatmentNotes}
                onChange={onActiveTreatmentNotesChange}
              />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PersonalMedicalHistorySection;
